module.exports = __webpack_public_path__ + "assets/images/shop8.5de17f4e.png";